module.exports = __webpack_public_path__ + "static/media/1013220.443b4a21.png";